<template>
  <el-dialog
      :visible.sync="visible"
      title="出口发货单"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="95%"
      :append-to-body="true"
  >
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="100px">
      <el-row :gutter="16">
        <el-col :span="8">
          <el-form-item label="出口发票：" prop="receiptCode" label-width="120px">
            <common-drop v-model="dataForm.receiptCode" ref="codeDrop" url="/trade/code/list" label-name="virtualCode"
                         val-name="virtualCode" size="mini" v-if="!$c.str2bool(dataForm.id)"
                         :filterable="true"></common-drop>
            <el-input v-else size="mini" :disabled="true" v-model="dataForm.receiptCode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户名称：">
            {{ customerName }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="装船日期：" prop="shipDate">
            <el-date-picker v-model="dataForm.shipDate" type="date" value-format="yyyy-MM-dd" style="width: 100%"
                            placeholder="选择出装船日期" size="mini">
            </el-date-picker>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row :gutter="16">
        <el-col :span="8">
          <el-form-item label="目的港：" prop="destination">
            <dict-dropdown v-model="dataForm.destination" size="mini" dictName="harbour"
                           :disabled="$c.str2bool(dataForm.id)"
                           :filterable="true"></dict-dropdown>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="船名：" prop="vesselName" label-width="80px">
            <el-input v-model="dataForm.vesselName" placeholder="船名" size="mini"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="出发港：" prop="fromHarbour" label-width="80px">
            <el-input v-model="dataForm.fromHarbour" placeholder="出发港" size="mini"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="table-bar" id="tableBar" style="justify-content: flex-start;align-items: center;margin-bottom: 0;">
        <div>
          <el-button size="mini" icon="el-icon-plus" @click="showMakeDetailDialog" type="primary">从工厂直接发货
          </el-button>
          <!--          <el-button size="mini" icon="el-icon-plus" @click="showSelBoxWithStore" type="primary">从历史库存发货-->
          <!--          </el-button>-->
        </div>
      </div>
      <SweetTable :data="dataForm.detailList" empty-text="请选择或导入发货品番" :is-page="false"
                  :height="500">
        <el-table-column label="外销合同号" prop="agreementCode" align="center" width="160"
                         :show-tooltip-when-overflow="true">
        </el-table-column>
        <el-table-column label="出货工厂" align="center" width="160" prop="factoryName"
                         :formatter="$c.companyNameFormatter" :show-tooltip-when-overflow="true">
        </el-table-column>
        <el-table-column label="货品信息" align="center">
          <template #default="{row}">
            <ProductRowCard :product="row.product"></ProductRowCard>
          </template>
        </el-table-column>
        <el-table-column label="发货数量" align="center" width="120">
          <template slot-scope="scope">
            <el-form-item :prop="'detailList.' + scope.$index + '.totalCount'"
                          :rules="detailRule.totalCount"
                          label-width="0" style="margin-top: 20px">
              <el-input size="mini" v-model="scope.row.totalCount" placeholder="出货数量"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="发货单价" align="center" width="120">
          <template slot-scope="scope">
            <el-form-item :prop="'detailList.' + scope.$index + '.price'" :rules="detailRule.price" label-width="0"
                          style="margin-top: 20px">
              <el-input size="mini" v-model="scope.row.price" placeholder="出货单价"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="每箱入数" align="center" width="120">
          <template slot-scope="scope">
            <el-form-item :prop="'detailList.' + scope.$index + '.preBoxCount'" :rules="detailRule.preBoxCount"
                          label-width="0" style="margin-top: 20px">
              <el-input size="mini" v-model="scope.row.preBoxCount" placeholder="每箱入数"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="箱数" header-align="center" align="center" width="120">
          <template slot-scope="scope">
            <el-form-item :prop="'detailList.' + scope.$index + '.boxCount'" :rules="detailRule.boxCount"
                          label-width="0" style="margin-top: 20px">
              <el-input size="mini" v-model="scope.row.boxCount"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="纸箱尺寸" header-align="center">
          <el-table-column label="长(cm)" header-align="center" align="center" width="120">
            <template slot-scope="scope">
              <el-form-item :prop="'detailList.' + scope.$index + '.boxLong'" :rules="detailRule.boxLong"
                            label-width="0" style="margin-top: 20px">
                <el-input size="mini" v-model="scope.row.boxLong"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="宽(cm)" header-align="center" align="center" width="120">
            <template slot-scope="scope">
              <el-form-item :prop="'detailList.' + scope.$index + '.boxWidth'" :rules="detailRule.boxWidth"
                            label-width="0" style="margin-top: 20px">
                <el-input size="mini" v-model="scope.row.boxWidth"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="高(cm)" header-align="center" align="center" width="120">
            <template slot-scope="scope">
              <el-form-item :prop="'detailList.' + scope.$index + '.boxHeight'" :rules="detailRule.boxHeight"
                            label-width="0" style="margin-top: 20px">
                <el-input size="mini" v-model="scope.row.boxHeight"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="毛重(kg)" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            <el-form-item :prop="'detailList.' + scope.$index + '.weight'" :rules="detailRule.weight" label-width="0"
                          style="margin-top: 20px">
              <el-input size="mini" v-model="scope.row.weight"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" width="100" label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button icon="el-icon-remove" type="text" @click="delRow(scope.$index, scope.row)">
              移除
            </el-button>
          </template>
        </el-table-column>
      </SweetTable>
    </el-form>
    <template slot="footer">
      <el-button @click="visible=false" size="mini">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="doSubmit()" size="mini">{{ $t('confirm') }}
      </el-button>
    </template>
    <MakeDetailDialog ref="makeDetailDialog" :disabled-query="['customerId']"
                      @selected="makeDetailSelected"></MakeDetailDialog>
  </el-dialog>
</template>

<script>
import MakeDetailDialog from '@/views/modules/erp/make/make-detail-dialog.vue'
import { moneyValidator, isPositiveNumber } from '@/utils/validate'
import CommonDrop from '@/components/CommonDrop'
import DictDropdown from '@/components/DictDropdown/index.vue'
import ProductRowCard from '@/components/ProductRowCard.vue'
import BigNumber from 'bignumber.js'

/**
 * 外销,出口发货单创建/编辑
 */
export default {
  name: 'CreateOutletBox',
  components: { ProductRowCard, CommonDrop, DictDropdown, MakeDetailDialog },
  data () {
    return {
      dataForm: {
        detailList: []
      },
      id: '',
      visible: false,
      customerName: '',
      customerId: ''
    }
  },
  watch: {
    'dataForm.receiptCode': {
      handler (val) {
        console.log('receiptCode change', val)
        if (val) {
          let c = this.$refs.codeDrop.dataList.find(item => item.virtualCode === val)
          if (c) {
            this.customerId = c.customerId
            this.customerName = c.customerName
            return
          }
        }
        this.customerId = ''
        this.customerName = ''
      },
      immediate: true
    }
  },
  computed: {
    detailRule () {
      const numValidate = function (rule, value, callback) {
        if (!value) {
          callback()
        }
        let reg = /\d+/g
        if (!reg.test(value)) {
          callback(new Error('请输入正确的数字'))
        }
        callback()
      }
      return {
        boxCount: [{ validator: numValidate, trigger: 'change' }],
        preBoxCount: [{ validator: numValidate, trigger: 'change' }],
        boxLong: [{ validator: numValidate, trigger: 'change' }],
        boxWidth: [{ validator: numValidate, trigger: 'change' }],
        boxHeight: [{ validator: numValidate, trigger: 'change' }],
        weight: [{ validator: numValidate, trigger: 'change' }],
        totalCount: [
          { required: true, message: '请填写数量', trigger: 'change' },
          {
            validator: (rule, value, callback, source, options, msg) => {
              if (!isPositiveNumber(value)) {
                callback(new Error('请输入正确的数量'))
              }
              if (parseFloat(value) <= 0) {
                callback(new Error('数量必须为正数'))
              }
              callback()

            }, trigger: 'change'
          },
        ],
        price: [
          { required: true, message: '请填写单价', trigger: 'change' },
          { validator: moneyValidator, trigger: 'change' },
        ],
      }
    },
    dataRule () {
      return {
        customerId: [
          { required: true, message: '请选择客户', trigger: 'change' }],
        taxCode: [
          { required: true, message: '请填写税号', trigger: 'change' }],
        destination: [
          { required: true, message: '请填写箱单目的地', trigger: 'change' }],
        receiptCode: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change',
          },
        ],
        shipDate: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change',
          },
        ],
      }
    },
  },
  methods: {
    showMakeDetailDialog () {
      let exIds = this.dataForm.detailList.filter(item => item.makeDetailId).map(item => item.makeDetailId)
      this.$refs.makeDetailDialog.init(exIds, this.customerId)
    },
    makeDetailSelected (data) {
      data.forEach(item => {
        this.dataForm.detailList.push({
          id: null,
          storeLogId: null,
          agreementCode: item.orderCode,
          factoryId: item.sellerId,
          factoryName: item.sellerName,
          product: item.product,
          totalCount: null,
          price: item.orderPrice,
          preBoxCount: '',
          boxCount: '',
          boxLong: '',
          boxWidth: '',
          boxHeight: '',
          weight: '',
          makeId: item.makeId,
          makeDetailId: item.id,
          isOldStore: false
        })
      })
    },
    async init () {
      if (this.id) {
        let loading = this.$loading()
        try {
          this.dataForm = await this.$api2.get(`/erp/box/${this.id}`)
        } finally {
          loading.close()
        }
        this.customerId = this.dataForm.customerId
        this.customerName = this.dataForm.customerName
      } else {
        this.dataForm = {
          detailList: [],
          receiptCode: '',
          shipDate: '',
          destination: '',
          vesselName: '',
          fromHarbour: '',
          formType: 'outlet'
        }
      }
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    delRow (index) {
      this.dataForm.detailList.splice(index, 1)
    },
    async doSave () {
      let postForm = {
        ...this.dataForm
      }
      postForm.detailList.forEach(item => {
        if (String(item.id).length < 4) {
          item.id = null
        }
        if (item.boxHeight && item.boxWidth && item.boxLong) {
          item.preSize = new BigNumber(item.boxHeight).multipliedBy(item.boxWidth).multipliedBy(item.boxLong)
          item.totalSize = item.preSize.multipliedBy(item.boxCount).toFixed(2)
          item.preSize = item.preSize.toFixed(2)
        }
      })
      let url = this.id ? '/erp/box/update' : '/erp/box/save'
      let loading = this.$loading()
      try {
        const res = await this.$api2.post(url, postForm)
        loading.close()
        this.$message.success(this.$t('prompt.success'))
        this.$emit('changed')
        this.visible = false
      } catch (e) {
        loading.close()
      }
    },
    doSubmit () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.doSave()
      })
    }
  }
}
</script>

<style scoped>

</style>
